import StockTakeMainPage from "./main.container";

export default StockTakeMainPage;
